import React from "react";
import "./loader.css";
import logo from "../assets/logo/logo-white.png";

const Loader = () => {
  return (
    <div className="loader-wrap">
      <img src={logo} alt="Infobizz Logo" className="loader-logo" />
      <p>Loading Infobizz...</p>
    </div>
  );
};

export default Loader;